import React from "react";

const SvgChevronRightBig = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M6.293 18.293a1 1 0 0 0 1.414 1.414l9-9a1 1 0 0 0 0-1.414l-9-9a1 1 0 0 0-1.414 1.414L14.586 10l-8.293 8.293z" /></svg>;

export default SvgChevronRightBig;